<template>
  <div :style="{width:'100%',height:'100%'}" >
    <div id="map" :style="{width:'100%',height:'100%'}"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import axios from 'axios'
import Firebase from './../../firebase'

export default {
  name: 'GoogleMap',
  computed: {
    ...mapState([
      'search',
      'DepLatLng',
      'DesLatLng',
      'originalApiData',
      'selectedSpotType'
    ])
  },
  data () {
    return {
      doneGetOriginApiData: false,
      mapName: 'map',
      element: null,
      latlng: null,
      mapOptions: null,
      map: null,
      markers: [],
      selectedId: null,
      routeMarkers: [],
      spots: [{
        type: '飲食店',
        list: []
      }, {
        type: '買い物',
        list: []
      }, {
        type: '観光',
        list: []
      }, {
        type: '温泉',
        list: []
      }],
      oriSpots: [{
        type: '飲食店',
        list: []
      }, {
        type: '買い物',
        list: []
      }, {
        type: '観光',
        list: []
      }, {
        type: '温泉',
        list: []
      }],
      youbi: ['日', '月', '火', '水', '木', '金', '土']
    }
  },
  methods: {
    ...mapMutations([
      'loadingEnd',
      'setOriginalApiData',
      'setSelectedSpot',
      'loadingStartMini',
      'loadingEndMini'
    ]),
    /**
     * マップのロード
     */
    loadMap () {
      this.element = document.getElementById(this.mapName)
      this.latlng = new window.google.maps.LatLng(36.65, 138.180)
      this.mapOptions = {
        zoom: 12,
        center: this.latlng,
        gestureHandling: 'greedy',
        scaleControl: false,
        mapTypeControl: false,
        zoomControl: true,
        streetViewControl: false,
        fullscreenControl: false
      }
      this.map = new window.google.maps.Map(this.element, this.mapOptions)
      const trafficLayer = new window.google.maps.TrafficLayer()
      trafficLayer.setMap(this.map)
      this.loadingEnd()
    },
    setDefaultMarker (position) {
      let marker = new window.google.maps.Marker({
        position,
        map: this.map
      })
      this.routeMarkers.push(marker)
    },
    setMarkerByGmap (position, data) {
      let originalData = this.originalApiData.filter(x => x.service_place_id === data.place_id)[0]

      let spotTypeText
      let congestionNum = 0
      if (this.selectedSpotType === '飲食店') spotTypeText = 'restaurant'
      else if (this.selectedSpotType === '買い物') spotTypeText = 'shop'
      else if (this.selectedSpotType === '観光') spotTypeText = 'sight'
      else if (this.selectedSpotType === '温泉') spotTypeText = 'leisure'

      if (originalData) {
        if (originalData.reports && originalData.reports.length > 0) {
          congestionNum = originalData.reports[0].congestion
        }
      }

      let markerImage = new window.google.maps.MarkerImage(
        this.loadImg(spotTypeText + '-' + congestionNum + '.png'),
        null, null, null,
        new window.google.maps.Size(30, 30)
      )
      const marker = new window.google.maps.Marker({
        position,
        map: this.map,
        icon: markerImage
      })

      // マーカーがクリックされた場合
      if (data) {
        marker.addListener('click', (event) => {
          var setSelectedSpot = this.setSelectedSpot
          var service = new window.google.maps.places.PlacesService(this.map)
          service.getDetails({
            placeId: data.place_id
          }, function (results, status) {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              setSelectedSpot(results)
              Firebase.putLog({ ActionType: 'TapSpot' })
            }
          })
        })
      }
      let list = this.spots.filter(x => x.type === this.selectedSpotType)[0]
      list.list.push(marker)
    },
    setMarkerByOriginalApi (position, data) {
      let spotType

      if (data.category === 1) spotType = '飲食店'
      else if (data.category === 2) spotType = '買い物'
      else if (data.category === 3) spotType = '観光'
      else if (data.category === 4) spotType = '温泉'

      let spotTypeText
      if (spotType === '飲食店') spotTypeText = 'restaurant'
      else if (spotType === '買い物') spotTypeText = 'shop'
      else if (spotType === '観光') spotTypeText = 'sight'
      else if (spotType === '温泉') spotTypeText = 'leisure'

      let congestionNum = 0
      if (data.reports.length) {
        congestionNum = data.reports[0].congestion
      }

      let markerImage = new window.google.maps.MarkerImage(
        this.loadImg(spotTypeText + '-' + congestionNum + '.png'),
        null, null, null,
        new window.google.maps.Size(30, 30)
      )
      const marker = new window.google.maps.Marker({
        position,
        map: this.map,
        icon: markerImage
      })

      // マーカーがクリックされた場合
      if (data) {
        marker.addListener('click', (event) => {
          var setSelectedSpot = this.setSelectedSpot
          if (data.service_place_id) {
            var service = new window.google.maps.places.PlacesService(this.map)
            service.getDetails({
              placeId: data.service_place_id
            }, function (results, status) {
              if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                setSelectedSpot(results)
                Firebase.putLog({ ActionType: 'TapSpot' })
              }
            })
          } else {
            this.setSelectedSpot(data)
            Firebase.putLog({ ActionType: 'TapSpot' })
          }
        })
      }
      let list = this.oriSpots.filter(x => x.type === spotType)[0]
      list.list.push(marker)
    },
    setMarkersVisble () {
      var bounds = new window.google.maps.LatLngBounds()
      let onlyDepFlg = true

      for (let spotlist of this.spots) {
        for (let spot of spotlist.list) {
          spot.setVisible(spotlist.type === this.selectedSpotType)
          bounds.extend(spot.position)
          onlyDepFlg = false
        }
      }
      for (let spotlist of this.oriSpots) {
        for (let spot of spotlist.list) {
          spot.setVisible(spotlist.type === this.selectedSpotType)
          bounds.extend(spot.position)
          onlyDepFlg = false
        }
      }

      bounds.extend(this.DepLatLng)
      this.map.fitBounds(bounds)
      if (onlyDepFlg) {
        this.map.setZoom(9)
      }
      this.loadingEndMini()
    },
    convertStartTime () {
      const time = new RegExp('([0-9]{2})', 'g')
      let parsedString = this.search.departureTime.match(time)
      var now = new Date()
      var dt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), parsedString[0], parsedString[1], now.getMinutes())

      return dt
    },
    searchRoute () {
      this.setDefaultMarker(this.DepLatLng)
      this.setDefaultMarker(this.DesLatLng)

      var directionsService = new window.google.maps.DirectionsService()
      var directionsDisplay = new window.google.maps.DirectionsRenderer({
        map: this.map,
        suppressMarkers: true
      })
      directionsService.route({
        origin: this.DepLatLng,
        destination: this.DesLatLng,
        travelMode: window.google.maps.TravelMode.DRIVING,
        drivingOptions: {
          departureTime: this.convertStartTime(),
          trafficModel: 'bestguess'
        }
      }, function (response, status) {
        if (status === window.google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response)
          navigator.geolocation.getCurrentPosition(function (position) {
            Firebase.putLog({
              ActionType: 'SearchRouteResults',
              CurrentLatLon: {
                current_lat: position.coords.latitude,
                current_lon: position.coords.longitude
              },
              duration_value: response.routes[0].legs[0].duration_in_traffic.value
            })
          },
          function (err) {
            var msgs = [
              err.message,
              '位置情報の取得を許可されていません。',
              '位置情報の取得に失敗しました。',
              '位置情報を取得中にタイムアウトしました。'
            ]
            window.alert(msgs[err.code])
          },
          { maximumAge: 0 })
        } else {
          Firebase.putLog({ ActionType: 'Debug',
            status: status,
            origin: this.DepLatLng,
            destination: this.DesLatLng
          })
        }
      })
    },
    loadImg (img) {
      return require(`@/assets/${img}`)
    },
    searchNearby () {
      this.loadingStartMini()
      if (this.spots.filter(x => x.type === this.selectedSpotType)[0].list.length !== 0) {
        this.setMarkersVisble()
        return 0
      }
      var service = new window.google.maps.places.PlacesService(this.map)
      var setMarkerByGmap = this.setMarkerByGmap
      var setMarkersVisble = this.setMarkersVisble
      service.nearbySearch({
        location: this.DesLatLng,
        radius: 5000,
        keyword: [this.selectedSpotType]
        // openNow: true
      }, function (results, status) {
        let length = 0

        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          length = results.length
          for (var i = 0; i < results.length; i++) {
            const item = results[i]
            var place = item.geometry.location
            if (item.business_status !== 'OPERATIONAL') {
              continue
            }
            setMarkerByGmap(place, results[i])
          }
          setMarkersVisble()
        }
        if (status === window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
          setMarkersVisble()
        }

        navigator.geolocation.getCurrentPosition(function (position) {
          Firebase.putLog({
            ActionType: 'SearchSpots',
            CurrentLatLon: {
              current_lat: position.coords.latitude,
              current_lon: position.coords.longitude
            },
            result_count: length,
            RelatedJsonData: results
          })
        },
        function (err) {
          var msgs = [
            err.message,
            '位置情報の取得を許可されていません。',
            '位置情報の取得に失敗しました。',
            '位置情報を取得中にタイムアウトしました。'
          ]
          window.alert(msgs[err.code])
        },
        { maximumAge: 0 })
      })
    },
    setDoneGetOriginApiData () {
      this.doneGetOriginApiData = true
    },
    getOriginalApiData () {
      this.loadingStartMini()
      let setDoneGetOriginApiData = this.setDoneGetOriginApiData
      let setOriginalApiData = this.setOriginalApiData
      let param = {
        api_key: 'fear76itkuyft',
        lat: this.DesLatLng.lat(),
        lng: this.DesLatLng.lng()
      }
      // const now = new Date()
      // const nowYoubi = this.youbi[now.getDay()]
      // const nowHourMin = now.getHours() + now.getMinutes() / 60

      axios.get('https://trafficwebapp2020runproduction-5p2gwks67q-uc.a.run.app/api/spots/', {params: param})
        .then((response) => {
          setOriginalApiData(response.data)
          for (let i = 0; i < response.data.length; i++) {
            let item = response.data[i]
            // const b = item.business_hours
            let out = false
            // if (!!b && b.length > 0) {
            //   b.split(',').forEach(function (d) {
            //     const pair = d.split(':')
            //     try {
            //       if (pair[0] && pair[1]) {
            //         const w = pair[0].trim()
            //         const term = pair[1].trim()
            //         if (w.includes(nowYoubi + '曜')) {
            //           const startEnd = term.split('～')
            //           const start = startEnd[0]
            //           const end = startEnd[1]
            //           if (start && end) {
            //             const startResult = start.match(/(\d+)時(\d+)分/)
            //
            //             const endResult = end.match(/(\d+)時(\d+)分/)
            //             if (startResult && endResult) {
            //               const startHour = Number.parseInt(startResult[0])
            //               const startMin = Number.parseInt(startResult[1])
            //               const start2 = startHour + startMin / 60
            //
            //               const endHour = Number.parseInt(endResult[0])
            //               const endMin = Number.parseInt(endResult[1])
            //               const end2 = endHour + endMin / 60
            //               if (nowHourMin < start2 || nowHourMin > end2) { // 営業時間外を検出
            //                 out = true
            //               }
            //             }
            //           }
            //         }
            //       }
            //     } catch (e) {
            //       console.error(e)
            //     }
            //   })
            // }
            if (!out) {
              this.setMarkerByOriginalApi(
                new window.google.maps.LatLng(item.lat, item.lon),
                item
              )
            }
          }
          setDoneGetOriginApiData()
        })
        .catch((e) => {
          this.searchNearby()
          setDoneGetOriginApiData()
        })
    }
  },
  mounted () {
    this.loadingStartMini()
    this.loadMap()
    this.searchRoute()
    this.getOriginalApiData()
  },
  watch: {
    selectedSpotType: {
      immideate: true,
      handler: function () {
        if (this.doneGetOriginApiData) {
          this.searchNearby()
        }
      }
    },
    originalApiData: {
      immideate: true,
      handler: function () {
        this.searchNearby()
      }
    }
  }
}
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 100px;
  margin: 0 auto;
  background: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/GoogleMap.vue